import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';

export default function LoadListListItemIndexReturned(props) {
    //console.debug("RTS Break LoadListListItemIndexReturned");

    const remains = Math.floor(props.data.amt - props.data.curPullSum);
    const netWeight = Math.floor(remains * props.data.productFtWeight);

    function formatDate(value){
        if(value == null){
            return null;
        }
        
        const formatObj = new Intl.DateTimeFormat("en-US");
        return (
            formatObj.format(new Date(value))
        );
    }

    return (
        <Stack sx={{textAlign:'center'}}>
            <Box sx={{width:'150px'}}>
                <>
                <Box sx={{display:'flex', width:'100%', justifyContent:'center', alignContent:'center'}}>
                    <Typography variant="body2" sx={{mr:1}}>Date: </Typography>
                    <Typography variant="body2">{formatDate(props.data.returnedDate)}</Typography>
                </Box>
                </>
                {
                props.data.markEmptyScrap === 1
                ?
                    <>
                    <Stack sx={{textAlign:'center'}}>
                        <Typography variant="body2" sx={{fontWeight:'bold'}}>Scrap Remaining</Typography>
                        <Box sx={{display:'flex', alignItems:'center', justifyContent:'center'}}>
                            <Box sx={{display:'flex'}}>
                                <Typography variant="body2">{remains.toLocaleString(undefined, { maximumFractionDigits: 2 })}</Typography>
                                <Typography variant="body2" sx={{ml:'2px'}}>ft</Typography>
                            </Box>
                        </Box>
                        <Box sx={{display:'flex', alignItems:'center', justifyContent:'center'}}>
                            <Box sx={{display:'flex'}}>
                                <Typography variant="caption">{netWeight.toLocaleString(undefined, { maximumFractionDigits: 2 })}</Typography>
                                <Typography variant="caption" sx={{ml:'2px'}}>lbs</Typography>
                            </Box>
                        </Box>                
                    </Stack>
                    </>
                
                :
                    props.data.markEmptyScrap === 0
                    ?
                    <>
                        <Typography variant="body2">Reel Returned Empty</Typography>
                    </>
                    :
                    <>
                        <Typography variant="body2">Reel Returned Outside of System</Typography>
                    </>
                }
            </Box>
        </Stack>
    );
}
